import Model from 'modules/reports/orm/Model'

export default class Account extends Model {
  id: number
  name: string
}
